module.exports = __webpack_public_path__ + "static/media/nutrition.062ddcd4.svg";